import React from 'react'

const Cr = () => {
    return (
        <div className='container'>
            <h1>Program to calculate value of nCr</h1>
            <p>Following are common definition of Binomial Coefficients. </p>
            <ol>
                <li>A binomial coefficient C(n, k) can be defined as the coefficient of X^k in the expansion of (1 + X)^n.</li>
                <li>A binomial coefficient C(n, k) also gives the number of ways, disregarding order, that k objects can be chosen from 
                    among n objects; more formally, the number of k-element subsets (or k-combinations) of an n-element set.</li>
            </ol>
            <p>Given two numbers n and r, find value of <sup>n</sup>C<sub>r</sub><br/><strong>Examples :</strong>&nbsp;<br/>&nbsp;</p>
            <div className='output'>
                <p><strong>Output:</strong></p>
                Input :  n = 5, r = 2 <br />
Output : 10 <br />
The value of 5C2 is 10 <br />
<p><strong>Formula Used</strong></p>
<p><sup>n</sup>C<sub>r</sub> = (n!) / (r! * (n-r)!)</p>
            </div>
            <div class="containers"> 
    <div class="line number1 index0 alt2"><code class="comment">// Program To calculate The Value Of nCr</code>
    </div> <br/>
    <div class="line number2 index1 alt1"><code class="library">#include &lt;bits/stdc++.h&gt;</code></div> <br/>
    <div class="line number3 index2 alt2"><code class="keywords">using</code> <code
            class="keywords">namespace</code> <code class="plain">std;</code></div> <br/>
    
    <div class="line number5 index4 alt2"><code class="library">int</code> <code class="plain">fact(</code><code
            class="library">int</code> <code class="plain">n);</code></div> <br/>
   
    <div class="line number7 index6 alt2"><code class="library">int</code> <code class="plain">nCr(</code><code
            class="library">int</code> <code class="plain">n, </code><code class="library">int</code> <code
            class="plain">r)</code></div> <br/>
    <div class="line number8 index7 alt1"><code class="plain">&#123;</code></div> <br/>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">return</code> <code class="plain">fact(n) / (fact(r) * fact(n - r));</code></div> <br/>
    <div class="line number10 index9 alt1"><code class="plain">&#125;</code></div> <br/>
 
    <div class="line number12 index11 alt1"><code class="comment">// Returns factorial of n</code></div> <br/>
    <div class="line number13 index12 alt2"><code class="library">int</code> <code class="plain">fact(</code><code
            class="library">int</code> <code class="plain">n)</code></div> <br/>
    <div class="line number14 index13 alt1"><code class="plain">&#123;</code></div> <br/>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="library">int</code> <code class="plain">res = 1;</code></div> <br/>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">for</code> <code class="plain">(</code><code class="library">int</code> <code
            class="plain">i = 2; i &lt;= n; i++)</code></div> <br/>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">res = res * i;</code></div> <br/>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">return</code> <code class="plain">res;</code></div> <br/>
    <div class="line number19 index18 alt2"><code class="plain">&#125;</code></div> <br/>

    <div class="line number21 index20 alt2"><code class="comment">// Driver code</code></div> <br/>
    <div class="line number22 index21 alt1"><code class="library">int</code> <code class="plain">main()</code></div> <br/>
    <div class="line number23 index22 alt2"><code class="plain">&#123;</code></div> <br/>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="library">int</code> <code class="plain">n = 5, r = 3;</code></div> <br/>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; nCr(n, r);</code></div> <br/>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">return</code> <code class="plain">0;</code></div> <br/>
    <div class="line number27 index26 alt2"><code class="plain">&#125;</code></div> <br/>
</div> <br/>
<div className='output'>
    <p><strong>Output:</strong></p>
    10
</div>
        </div>
    )
}

export default Cr
